import toastr from "toastr";

;(function ($) {
	"use strict";
	window.Sheriff = function (options) {
		this._init(options);
	};

	$.extend(Sheriff.prototype, {
		$options: {
			cameraNumOld: null,
			radioNumOld: null
		},

		passwordChange: function (input) {
			if (input.value.length > 0)
			{
				$('#inputPasswordConfirm').attr('required', 'required');
			}
			else
			{
				$('#inputPasswordConfirm').removeAttr('required').change();
			}
		},

		downloadRights: function ($button) {
			let $form,
				group = $('#group').val();

			$.ajax({
				url:  route('sheriffs.getGroupRights', {'group': group}),
				method: 'get',
				dataType: 'json',
				success: function (result) {
					if ('rights' in result) {
						$('input:checkbox[name^=rights]').each(function (i, e) { e.checked = false; });
						$.each(result.rights, function (i, e) {
							let input = $('input:checkbox.right-checkbox-'+e+'').get(0);
							if (input) {
								input.checked = true;
							}
						});
					}
				},
				error: function (result) {
					toastr.error(result.error);
				},
			});
		},

		/**
		 * @param $button
		 */
		uploadRights: function ($button) {
			let $form = $button.closest('form'),
				formData = $form.serializeArray(),
				group = $('#group').val(),
				rights = [];
			//Go through all form data
			$.each(formData, function (i, e) {
				//Check input validity
				if (e && ('name' in e)) {
					//Find rights inputs
					let matches = e.name.match(/rights\[(\d+)\]/);
					if (matches) {
						//Add right ID to the array
						rights.push(matches[1]);
					}
				}
			});

			$.ajax({
				url:  route('sheriffs.setGroupRights', {'group': group}),
				method: 'post',
				dataType: 'json',
				data: { rights: rights },
				success: function (result) {
					toastr.success(result.message);
				},
				error: function (result) {
					toastr.error(result.error);
				},
			});
		},

		storeOldValues: function () {
			let app = this;

			app.$options.cameraNumOld = $('#cameraNumber').val();
			app.$options.radioNumOld = $('#walkieTalkieNumber').val();
		},

		rewriteValuesInDayShifts: function () {
			const 	app = this,
				  	lang = $Lang.sheriffs,
					rewriteValuesInput = $('#rewriteValuesInDayShift');

			const valuesChanged = (app.$options.cameraNumOld !== $('#cameraNumber').val()) || (app.$options.radioNumOld !== $('#walkieTalkieNumber').val());

			if (valuesChanged)
			{
				bootbox.confirm({
					'title': lang.cameraOrRadioNumber,
					'message': lang.rewriteCameraOrRadioNumber,
					'callback': function (result) {

						rewriteValuesInput.val(result);
						$('#sheriffForm').trigger('submit');
					}
				});
			}
			else
			{
				$('#sheriffForm').trigger('submit');
			}
		},
		
		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('change', '#inputPassword', function () {
				app.passwordChange(this);
			});
			
			$document.on('click', '.js-download-group-rights', function (e) {
				e.preventDefault();
				app.downloadRights($(this));
			});
			$document.on('click', '.js-upload-group-rights', function (e) {
				e.preventDefault();
				app.uploadRights($(this));
			});
			$document.on('click', '#sheriffForm input[type="submit"]', function (e) {
				e.preventDefault();
				app.rewriteValuesInDayShifts();
			})
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});

			$('#sheriffForm').validator();

			this.handleButtons();

			this.storeOldValues();
		}
	});

})(jQuery);

